import React, { useState } from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import WorkplaceWorkerDetail from './WorkplaceWorkerDetail';
import { Size } from '../../../../../Enums/Size.enum';

interface Props {
	isOpen: boolean;
	userId: string;
	onClose: () => void;
	showAllWorkplaces: boolean;
	onWorkplaceEdit: () => void;
}

const WorkplaceWorkerDetailModal: React.FC<Props> = ({
	isOpen,
	onClose,
	userId,
	showAllWorkplaces,
	onWorkplaceEdit,
}) => {
	const [doListRefresh, setDoListRefresh] = useState(false);

	const handleClose = () => {
		if (doListRefresh) {
			onWorkplaceEdit();
		}
		onClose();
	};

	const handleCloseAndReload = () => {
		onWorkplaceEdit();
		onClose();
	};

	return (
		<Modal opened={isOpen} onClose={handleClose} size={Size.XL}>
			<Modal.Header
				title='component.workplaceAndWorkers.employeeProfile'
				firstUpper
			/>
			<Modal.Content>
				<WorkplaceWorkerDetail
					userId={userId}
					showAllWorkplaces={showAllWorkplaces}
					setDoListRefresh={setDoListRefresh}
					closeAndReload={handleCloseAndReload}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default WorkplaceWorkerDetailModal;
